<template>
  <overview-section-card v-if="showSteps" section-class="project-steps mb-6">
    <v-card-title
      class="project-steps__title pb-2 flex-column flex-sm-row align-start align-sm-center justify-sm-space-between"
    >
      <span class="overview-section-title">
        {{ $t('overview.steps_subtitle') }}
      </span>
    </v-card-title>
    <v-card-text class="pt-2 pb-4">
        <v-row dense class="project-steps__row">
          <v-col cols="12" sm="6" md="4">
            <todo-list-item
              :text="$t('overview.todo_item_1')"
              redirect-path="/import"
              hint-number="1"
              icon="mdi-cloud-upload-outline"
              :condition="imagesNotPresent"
              :is-next-open="nextOpenHintNumber === '1'"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <todo-list-item
              :text="$t('overview.todo_item_4')"
              redirect-path="/annotate"
              hint-number="2"
              icon="mdi-vector-square"
              :condition="annotationsNotPresent"
              :is-next-open="nextOpenHintNumber === '2'"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <todo-list-item
              :text="$t('overview.todo_item_6')"
              redirect-path="/models"
              hint-number="3"
              icon="mdi-brain"
              :condition="trainingNotStarted"
              :is-next-open="nextOpenHintNumber === '3'"
            />
          </v-col>
        </v-row>
    </v-card-text>
  </overview-section-card>
</template>

<script>
import TodoListItem from '@/components/TodoListItem';
import OverviewSectionCard from '@/components/overview/OverviewSectionCard.vue';

export default {
  name: 'ProjectTodoList',
  components: {
    TodoListItem,
    OverviewSectionCard,
  },
  data() {
    return {
      imagesNotPresent: null,
      annotationsNotPresent: null,
      trainingNotStarted: null,
    };
  },
  computed: {
    /** Hide the whole widget once import + annotations are done (step 3 is on the models page). */
    showSteps() {
      if (this.imagesNotPresent === null || this.annotationsNotPresent === null) {
        return true;
      }
      return this.imagesNotPresent || this.annotationsNotPresent;
    },
    nextOpenHintNumber() {
      const pending = [
        this.imagesNotPresent,
        this.annotationsNotPresent,
        this.trainingNotStarted,
      ];
      if (pending.some((v) => v === null)) {
        return null;
      }
      for (let i = 0; i < pending.length; i++) {
        if (pending[i] === true) {
          return String(i + 1);
        }
      }
      return null;
    },
  },
  mounted() {
    this.getTodoListBooleans();
  },
  methods: {
    async getTodoListBooleans() {
      const response = await this.$api.overview.get_todo_list_booleans();
      if (response) {
        this.imagesNotPresent = response.imagesNotPresent;
        this.annotationsNotPresent = response.annotationsNotPresent;
        this.trainingNotStarted = response.trainingNotStarted;
      }
    },
  },
};
</script>

<style scoped>
.project-steps__title {
  flex-wrap: wrap;
  gap: 8px;
}

.project-steps__row {
  margin-left: -8px;
  margin-right: -8px;
}
</style>
